"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RectCopySelector = void 0;

var Point2D_1 = require("../../Core/Point2D");

var Rect_1 = require("../../Core/Rect");

var RegionData_1 = require("../../Core/RegionData");

var CrossElement_1 = require("../Component/CrossElement");

var RectElement_1 = require("../Component/RectElement");

var Selector_1 = require("./Selector");
/**
 * The selector to define a rect-region using a template.
 */


var RectCopySelector = /*#__PURE__*/function (_Selector_1$Selector) {
  _inherits(RectCopySelector, _Selector_1$Selector);

  /**
   * Creates new `RectCopySelector` object.
   * @param parent - The parent SVG-element.
   * @param paper - The `Snap.Paper` element to draw on.
   * @param boundRect - The bounding box.
   * @param copyRect - The template rect for selection.
   * @param callbacks - The collection of callbacks.
   */
  function RectCopySelector(parent, paper, boundRect, copyRect, callbacks) {
    var _this;

    _classCallCheck(this, RectCopySelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RectCopySelector).call(this, parent, paper, boundRect, callbacks));
    _this.copyRect = copyRect;

    _this.buildUIElements();

    _this.hide();

    return _this;
  }
  /**
   * Updates the template for selector.
   * @param copyRect - New template rect.
   */


  _createClass(RectCopySelector, [{
    key: "setTemplate",
    value: function setTemplate(copyRect) {
      this.copyRect = new Rect_1.Rect(copyRect.width, copyRect.height);
      this.copyRectEl.resize(copyRect.width, copyRect.height);
      this.moveCopyRect(this.copyRectEl, this.crossA);
    }
    /**
     * Resizes the selector to specified `width` and `height`.
     * @param width - The new `width`.
     * @param height - The new `height`.
     */

  }, {
    key: "resize",
    value: function resize(width, height) {
      _get(_getPrototypeOf(RectCopySelector.prototype), "resize", this).call(this, width, height);

      this.crossA.resize(width, height);
    }
    /**
     * Hides the selector.
     */

  }, {
    key: "hide",
    value: function hide() {
      _get(_getPrototypeOf(RectCopySelector.prototype), "hide", this).call(this);

      this.hideAll([this.crossA, this.copyRectEl]);
    }
    /**
     * Shows the selector.
     */

  }, {
    key: "show",
    value: function show() {
      _get(_getPrototypeOf(RectCopySelector.prototype), "show", this).call(this);

      this.showAll([this.crossA, this.copyRectEl]);
    }
    /**
     * Builds selector's UI.
     */

  }, {
    key: "buildUIElements",
    value: function buildUIElements() {
      this.node = this.paper.g();
      this.node.addClass("rectCopySelector");
      this.crossA = new CrossElement_1.CrossElement(this.paper, this.boundRect);
      this.copyRectEl = new RectElement_1.RectElement(this.paper, this.boundRect, this.copyRect);
      this.copyRectEl.node.addClass("copyRectStyle");
      this.node.add(this.crossA.node);
      this.node.add(this.copyRectEl.node);
      var listeners = [{
        event: "pointerenter",
        listener: this.onPointerEnter,
        base: this.parentNode,
        bypass: false
      }, {
        event: "pointerleave",
        listener: this.onPointerLeave,
        base: this.parentNode,
        bypass: false
      }, {
        event: "pointerdown",
        listener: this.onPointerDown,
        base: this.parentNode,
        bypass: false
      }, {
        event: "pointerup",
        listener: this.onPointerUp,
        base: this.parentNode,
        bypass: false
      }, {
        event: "pointermove",
        listener: this.onPointerMove,
        base: this.parentNode,
        bypass: false
      }, {
        event: "wheel",
        listener: this.onWheel,
        base: this.parentNode,
        bypass: false
      }];
      this.subscribeToEvents(listeners);
    }
    /**
     * Helper function to move rect to specified point.
     * @param copyRect - The rect element to move.
     * @param p - The new location.
     */

  }, {
    key: "moveCopyRect",
    value: function moveCopyRect(copyRect, p) {
      var x = p.x - copyRect.rect.width / 2;
      var y = p.y - copyRect.rect.height / 2;
      copyRect.move(new Point2D_1.Point2D(x, y));
    }
    /**
     * Listener for the pointer enter event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerEnter",
    value: function onPointerEnter(e) {
      var _this2 = this;

      window.requestAnimationFrame(function () {
        _this2.crossA.show();

        _this2.copyRectEl.show();
      });
    }
    /**
     * Listener for the pointer leave event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerLeave",
    value: function onPointerLeave(e) {
      var _this3 = this;

      window.requestAnimationFrame(function () {
        _this3.hide();
      });
    }
    /**
     * Listener for the pointer down event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerDown",
    value: function onPointerDown(e) {
      var _this4 = this;

      window.requestAnimationFrame(function () {
        _this4.show();

        _this4.moveCopyRect(_this4.copyRectEl, _this4.crossA);

        if (typeof _this4.callbacks.onSelectionBegin === "function") {
          _this4.callbacks.onSelectionBegin();
        }
      });
    }
    /**
     * Listener for the pointer up event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerUp",
    value: function onPointerUp(e) {
      var _this5 = this;

      window.requestAnimationFrame(function () {
        if (typeof _this5.callbacks.onSelectionEnd === "function") {
          var p1 = new Point2D_1.Point2D(_this5.crossA.x - _this5.copyRect.width / 2, _this5.crossA.y - _this5.copyRect.height / 2);
          var p2 = new Point2D_1.Point2D(_this5.crossA.x + _this5.copyRect.width / 2, _this5.crossA.y + _this5.copyRect.height / 2);
          p1 = p1.boundToRect(_this5.boundRect);
          p2 = p2.boundToRect(_this5.boundRect);
          var width = p2.x - p1.x;
          var height = p2.y - p1.y;
          var regionData = RegionData_1.RegionData.BuildRectRegionData(p1.x, p1.y, width, height);

          _this5.callbacks.onSelectionEnd(regionData);
        }
      });
    }
    /**
     * Listener for the pointer move event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerMove",
    value: function onPointerMove(e) {
      var _this6 = this;

      window.requestAnimationFrame(function () {
        var rect = _this6.parentNode.getClientRects();

        var p = new Point2D_1.Point2D(e.clientX - rect[0].left, e.clientY - rect[0].top);

        _this6.moveCross(_this6.crossA, p);

        _this6.moveCopyRect(_this6.copyRectEl, _this6.crossA);
      });
      e.preventDefault();
    }
    /**
     * Listener for the wheel event.
     * @param e WheelEvent
     */

  }, {
    key: "onWheel",
    value: function onWheel(e) {
      var _this7 = this;

      var width = this.copyRect.width;
      var height = this.copyRect.height;
      var k = height / width;

      if (e.shiftKey) {
        if (e.deltaY > 0) {
          width *= 1.1;
          height *= 1.1;
        } else {
          width /= 1.1;
          height /= 1.1;
        }
      } else {
        if (e.deltaY > 0) {
          width += 1.0;
          height += k;
        } else {
          width -= 1.0;
          height -= k;
        }
      }

      if (width < 1.0) {
        width = 1.0;
        height = k;
      }

      if (height < 1.0) {
        height = 1.0;
        width = 1.0 / k;
      }

      window.requestAnimationFrame(function () {
        _this7.copyRect.resize(width, height);

        _this7.copyRectEl.resize(width, height);

        _this7.moveCopyRect(_this7.copyRectEl, _this7.crossA);
      });
    }
  }]);

  return RectCopySelector;
}(Selector_1.Selector);

exports.RectCopySelector = RectCopySelector;